import { AuthApi } from './auth.api'
import { ClientApi } from './client.api'
import { CompanyApi } from './company.api'
import { DashboardApi } from './dashboard.api'
import { DataGridApi } from './datagrid.api'
import { DocumentsApi } from './documents.api'
import { EmailApi } from './email.api'
import { KvkApi } from './kvk.api'
import { OAuthApi } from './oauth.api'
import { PaymentApi } from './payment.api'
import { UserApi } from './user.api'
import { SharedApi } from './shared.api'
import { BaseApi } from '@api'
export { BaseApi } from './_base.api'
export type { IKvkCompany, IKvkSearchResponse, IKvkCompanyResponse, IKvkSearchQueryParams } from './kvk.api'

export interface IApi {
  instance: BaseApi
  auth: AuthApi
  user: UserApi
  client: ClientApi
  dashboard: DashboardApi
  datagrid: DataGridApi
  email: EmailApi
  kvk: KvkApi
  oauth: OAuthApi
  company: CompanyApi
  shared: SharedApi
  documents: DocumentsApi
  payment: PaymentApi
}

export default (): IApi => {
  const instance = new BaseApi()
  const auth = new AuthApi()
  const dashboard = new DashboardApi()
  const datagrid = new DataGridApi()
  const client = new ClientApi()
  const email = new EmailApi()
  const user = new UserApi()
  const kvk = new KvkApi()
  const oauth = new OAuthApi()
  const documents = new DocumentsApi()
  const company = new CompanyApi()
  const shared = new SharedApi()
  const payment = new PaymentApi()

  return { auth, user, kvk, oauth, company, client, dashboard, datagrid, email, shared, documents, payment, instance }
}
